<app-spinner />
<router-outlet></router-outlet>
<app-toast />

<app-update-dialog
  [show]="showUpdateDialog"
  [data]="updateData"
  (closed)="onCancel()"
  (confirmed)="onUpdate()"
></app-update-dialog>